import { useNotify, useRefresh } from "react-admin";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { candidateRequests } from "api/candidateApi";
import LoadingActionButton from "server/components/LoadingActionButton";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";

const ApproveExamResultsButton = ({ exam, isFinished }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const approveResults = async () => {
    await dataProvider.customRequest(candidateRequests.approveCampaignExamResults(exam.campaignExamId), null, "POST");
    notify("Оценките са финализирани успешно!", { type: "success" });
    refresh();
  };

  if (!exam) {
    return null;
  }

  return (
    <SecuredComponent permission={permissions.canApproveExamResults}>
      <ConfirmModal
        titleContent="Финализиране на оценки"
        triggerButton={
          <LoadingActionButton
            label="Финализирай оценки"
            icon={<FactCheckIcon />}
            disabled={exam.examFinalized || isFinished}
          />
        }
        onConfirm={approveResults}
        message="Сигурни ли сте, че искате да финализирате оценките от този изпит?"
      />
    </SecuredComponent>
  );
};

export default ApproveExamResultsButton;
